// @flow
import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl';
import { connect } from 'react-redux';

import type { ID_TYPE } from '../../types/common';
import * as selectors from '../../reducers';
import * as routesActions from '../../actions/routes';
import * as mapActions from '../../actions/map';
import DraggableMarker from '../DraggableMarker';
import styles from './mappoint.css';

type MapPointPropTypes = {
  map: mapboxgl.Map,
  latitude: number,
  longitude: number,
  // sourceName: string,
  id: ID_TYPE,
  isLast: boolean,
  isCurrent: boolean,
  onReposition?: Function,
  onDragStart?: Function,
  onClick?: Function
};

type MapPointStateTypes = {
  marker: mapboxgl.Marker
};

const getMarkerElementClasses = (isLast: boolean, isCurrent: boolean) => {
  const classes = [styles.circle];
  if (isLast) { classes.push(styles.last); }
  if (isCurrent) { classes.push(styles.current); }
  return classes;
};

class MapPoint extends Component<MapPointPropTypes, MapPointStateTypes> {
  componentDidMount() {
    const {
      map,
      id,
      latitude,
      longitude,
      isLast,
      isCurrent,
      onClick,
    } = this.props;

    // Points layer
    const element = document.createElement('div');
    element.onclick = onClick;
    const marker = new mapboxgl.Marker(element).setLngLat([longitude, latitude]).addTo(map);

    getMarkerElementClasses(isLast, isCurrent).forEach(
      className => element.classList.add(className),
    );

    // Bus id
    element.setAttribute('id', id.toString());
    this.setState({ marker });
  }

  componentWillReceiveProps(nextProps: MapPointPropTypes) {
    const { marker } = this.state;
    const {
      isLast,
      isCurrent,
      longitude,
      latitude,
    } = nextProps;

    const element = marker.getElement();
    element.className = '';

    getMarkerElementClasses(isLast, isCurrent).forEach(
      className => element.classList.add(className),
    );
    marker.setLngLat([longitude, latitude]);
  }

  componentWillUnmount() {
    const { marker } = this.state;
    marker.remove();
  }

  render() {
    const {
      map,
      longitude,
      latitude,
      isCurrent,
      onReposition,
      onDragStart,
    } = this.props;
    return (
      isCurrent
        ? (
          <DraggableMarker
            map={map}
            longitude={longitude}
            latitude={latitude}
            isPlaced
            onDragEnd={onReposition}
            onDragStart={onDragStart}
          />
        ) : null
    );
  }
}

export default connect(
  (state, { id }) => {
    const { route, point: { coordinates } } = selectors.getRouteStop(state, id);
    const stops = selectors.getRouteStops(state, route);
    const selectedRouteStopId = selectors.getCurrentRouteStopId(state);

    return {
      longitude: coordinates[0],
      latitude: coordinates[1],
      isLast: id === stops[stops.length - 1].id,
      isCurrent: id === selectedRouteStopId,
    };
  },
  (dispatch, { id }) => ({
    onDragStart() {
      dispatch(mapActions.setMapDirty());
    },
    onReposition(longitude, latitude) {
      dispatch(routesActions.updateRouteStop({
        id,
        point: {
          type: 'Point',
          coordinates: [longitude, latitude],
        },
        pointUpdated: true,
      }));
    },
    onClick(e: MouseEvent) {
      e.stopPropagation();
      dispatch(routesActions.setCurrentRouteStop(id));
    },
  }),
)(MapPoint);



// WEBPACK FOOTER //
// ./src/scripts/components/MapPoint/index.jsx